@if (item.navigationLink) {
  <div class="sh-compact-navigation__main-action-wrapper">
    <a href="{{ item.navigationLink?.route }}" target="{{ item.navigationLink?.target }}" class="sh-compact-navigation__main-action">
      <div class="sh-compact-navigation__main-action__icon-wrapper">
        <svg sh-icon [name]="item.icon" class="sh-compact-navigation__main-action__icon" aria-hidden="true"></svg>
      </div>
      <span class="sh-compact-navigation__main-action__label">{{ item.label }}</span>
    </a>
  </div>
} @else {
  <div
    class="sh-compact-navigation__main-action-wrapper"
    [class.sh-compact-navigation__dropmenu]="hasDropmenuItems"
    (mouseenter)="openSubMenu()"
    (mouseleave)="closeSubMenu()"
    (click)="openSubMenu()"
    (keyup.enter)="openSubMenu()"
    (shClickOutside)="closeSubMenu()"
    #detailsElement
    >
    <summary class="sh-compact-navigation__main-action" [class.sh-compact-navigation__dropmenu__header]="hasDropmenuItems">
      <div class="sh-compact-navigation__main-action__icon-wrapper">
        <svg sh-icon [name]="item.icon" class="sh-compact-navigation__main-action__icon" aria-hidden="true"></svg>
      </div>
      <span class="sh-compact-navigation__main-action__label">{{ item.label }}</span>
    </summary>
    @if (hasDropmenuItems) {
      <div class="sh-compact-navigation__dropmenu__list-wrapper">
        <ul class="sh-compact-navigation__dropmenu__list">
          @for (dropmenuItem of item.actionItems; track dropmenuItem) {
            <li class="sh-compact-navigation__dropmenu__list__item">
              <ng-container
                *ngTemplateOutlet="dropmenuItem.eventListener ? button : navigationLink; context: { dropmenuItem: dropmenuItem }"
              ></ng-container>
            </li>
          }
        </ul>
      </div>
    }
  </div>
}



<ng-template #button let-dropmenuItem="dropmenuItem">
  <button class="sh-compact-navigation__dropmenu__link sh-icon-link" (click)="actionClicked($event, dropmenuItem)">{{ dropmenuItem.label }}</button>
</ng-template>

<ng-template #navigationLink let-dropmenuItem="dropmenuItem">
  <a [shNavigationLink]="dropmenuItem.navigationLink" class="sh-compact-navigation__dropmenu__link sh-icon-link" (click)="closeSubMenu()">
    {{ dropmenuItem.label }}
  </a>
</ng-template>
